// (function () {
//   const IFRAME_ID = 'club-iframe';
//   const IFRAME_SELECTOR = '.iframeTemplate .wpIframeEmbed';
//   const GRID_GAP = 32;
//   const GRID_PADDING = 32;
//   const PAGE_CHROME_HEIGHT = 0;
//   let hasIframeMessageHeight = false;

//   function getIframe() {
//     return document.getElementById(IFRAME_ID) || document.querySelector(IFRAME_SELECTOR);
//   }

//   function getCardHeight(width) {
//     if (width >= 1536) {
//       return 1025; // desktop
//     }
//     if (width >= 1280) {
//       return 947; // desktop
//     }

//     if (width >= 1024) {
//       return 965; // tablet
//     }

//     if (width >= 768) {
//       return 1015; // tablet
//     }

//     if (width >= 650) {
//       return 1375; // tablet
//     }

//     return 1025; // mobile (default)
//   }

//   function prepareIframe(iframe) {
//     const container = iframe.closest('.embed-container');

//     iframe.id = IFRAME_ID;
//     iframe.style.display = 'block';
//     iframe.style.width = '100%';
//     iframe.style.border = 'none';
//     iframe.style.overflow = 'hidden';
//     iframe.setAttribute('scrolling', 'no');

//     if (container) {
//       container.style.paddingBottom = '0';
//       container.style.overflow = 'visible';
//     }
//   }

//   function getIssueCount(iframe) {
//     const issueCount = parseInt(iframe.getAttribute('data-iframe-issue-count'), 10);

//     return isFinite(issueCount) && issueCount > 0 ? issueCount : 0;
//   }

//   function getColumnCount(width) {
//     if (width >= 1280) {
//       return 4;
//     }

//     if (width >= 1024) {
//       return 3;
//     }

//     if (width >= 768) {
//       return 2;
//     }

//     return 1;
//   }

//   function getEstimatedArchiveHeight(iframe) {
//     const issueCount = getIssueCount(iframe);
//     const minHeight = window.innerHeight;

//     if (issueCount <= 0) {
//       return minHeight;
//     }

//     const iframeWidth = iframe.clientWidth || iframe.getBoundingClientRect().width || window.innerWidth || 320;
//     const columnCount = getColumnCount(iframeWidth);
//     const cardHeight = getCardHeight(iframeWidth);
//     const rowCount = Math.ceil(issueCount / columnCount);

//     return Math.max(Math.ceil((rowCount * cardHeight) + (Math.max(rowCount - 1, 0) * GRID_GAP)), minHeight);
//   }

//   function setIframeHeight(height) {
//     const iframe = getIframe();
//     const iframeHeight = parseInt(height, 10);

//     if (!iframe || !isFinite(iframeHeight) || iframeHeight <= 0) {
//       return;
//     }

//     prepareIframe(iframe);

//     iframe.style.height = `${iframeHeight}px`;
//     iframe.setAttribute('height', iframeHeight);

//     const container = iframe.closest('.embed-container');

//     if (container) {
//       container.style.height = `${iframeHeight}px`;
//     }
//   }

//   function handleIframeHeightMessage(event) {
//     if (!event.data || event.data.type !== 'iframeHeight') {
//       return;
//     }

//     hasIframeMessageHeight = true;
//     setIframeHeight(event.data.height);
//   }

//   function setEstimatedIframeHeight() {
//     const iframe = getIframe();

//     if (!iframe || hasIframeMessageHeight) {
//       return;
//     }

//     setIframeHeight(getEstimatedArchiveHeight(iframe));
//   }

//   function initIframe() {
//     const iframe = getIframe();

//     if (iframe) {
//       prepareIframe(iframe);
//       setEstimatedIframeHeight();
//     }
//   }

//   window.addEventListener('message', handleIframeHeightMessage);
//   window.addEventListener('resize', setEstimatedIframeHeight);

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', initIframe);
//   } else {
//     initIframe();
//   }
// }());

(function () {
  function initAutoIframe() {
    var iframe = document.querySelector('.iframeTemplate .wpIframeAutoHeight');

    if (!iframe) {
      return;
    }

    var container = iframe.closest('.embed-container');

    iframe.style.width = '100%';
    iframe.style.height = '100vh';
    iframe.style.border = '0';
    iframe.style.display = 'block';
    iframe.style.overflow = 'auto';
    iframe.setAttribute('scrolling', 'yes');

    if (container) {
      container.style.paddingBottom = '0';
      container.style.height = '100vh';
      container.style.overflow = 'visible';
    }

    window.addEventListener('message', function (event) {
      if (event.source !== iframe.contentWindow) {
        return;
      }

      if (!event.data || event.data.type !== 'iframeHeight') {
        return;
      }

      var height = parseInt(event.data.height, 10);

      if (!height || height <= 0) {
        return;
      }

      iframe.style.height = height + 'px';
      iframe.style.overflow = 'hidden';
      iframe.setAttribute('height', height);
      iframe.setAttribute('scrolling', 'no');

      if (container) {
        container.style.height = height + 'px';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAutoIframe);
  } else {
    initAutoIframe();
  }
})();